import { render } from "./UnSyncedInvPage.vue?vue&type=template&id=fde9a79e"
import script from "./UnSyncedInvPage.vue?vue&type=script&lang=js"
export * from "./UnSyncedInvPage.vue?vue&type=script&lang=js"

import "./UnSyncedInvPage.vue?vue&type=style&index=0&id=fde9a79e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__